import { render, staticRenderFns } from "./LinksCard.vue?vue&type=template&id=9597c152&scoped=true"
import script from "./LinksCard.vue?vue&type=script&lang=js"
export * from "./LinksCard.vue?vue&type=script&lang=js"
import style0 from "./LinksCard.vue?vue&type=style&index=0&id=9597c152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9597c152",
  null
  
)

export default component.exports